const { compareStrings } = require('@/functions/strings');
/**
 * Generates a function that can be used to sort an array by the property specified.
 *
 * @param {string} property
 * @param {function(object, object): number} [fallbackCompareFunc]
 *
 * @return {function(object, object): number}
 */
const createCompareFunc = (property, fallbackCompareFunc = null) => {
    return (a, b) => {
        if (String(a[property]) === String(b[property])) {
            // If the 2 values are the same compare with the fallbackCompareFunc if one was provided,
            // otherwise return 0.
            if (fallbackCompareFunc) {
                return fallbackCompareFunc(a, b);
            }

            return 0;
        }

        return a[property] > b[property] ? 1 : -1;
    };
};

const compareDescription = createCompareFunc('description');
const sortByDescription = (arr) => arr.sort(compareDescription);

const compareID = createCompareFunc('ID');
const sortByID = (arr) => arr.sort(compareID);

const compareName = (mainProperty, fallbackProperty = 'ID') => (a, b) => {
    const mainA = a[mainProperty] || '';
    const mainB = b[mainProperty] || '';
    const mainResult = compareStrings(mainA, mainB);

    return mainResult || compareStrings(a[fallbackProperty] || '', b[fallbackProperty] || '');
};
const sortByName = (arr) => arr.sort(compareName('name'));

const compareNavOrder = createCompareFunc('navOrder', compareID);
const sortByNavOrder = (arr) => arr.sort(compareNavOrder);

const compareStartTime = createCompareFunc('startTime', compareID);
const sortByStartTime = (arr) => arr.sort(compareStartTime);

const compareFulfillmentCreatedAt = createCompareFunc('fulfillmentCreatedAt', compareID);
const sortByFulfillmentCreatedAt = (arr) => arr.sort(compareFulfillmentCreatedAt);

module.exports = {
    createCompareFunc,
    sortByDescription,
    sortByFulfillmentCreatedAt,
    sortByID,
    sortByName,
    sortByNavOrder,
    sortByStartTime,
};
